import React from 'react'

// STYLES // 
import './stylesStreamCard.scss'

function StreamCard({streamName, streamLogo}) {

  const IMG_PATH= "https://image.tmdb.org/t/p/original"

  return (
    <div className='streamCard'>

        <img className='streamCard_image' src={ `${IMG_PATH}${streamLogo}`} alt='moviePoster' />
        <p className='streamCard_text'> {streamName} </p>
</div>

  )
}



export default StreamCard




